import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import type { EtcaRedirect } from '../../api/types/etcaRedirect.types';

export function useEtcaNavigation(data: EtcaRedirect | undefined): void {
    const navigate = useNavigate();
    const navigationDone = useRef(false);

    useEffect(() => {
        if (!data || navigationDone.current) return;

        navigationDone.current = true;

        navigate(`/manage/${data.customerId}/etca/${data.trainingEventId}`, { replace: true });
    }, [data, navigate]);
}
